// extracted by mini-css-extract-plugin
module.exports = {"xsmall":"Text_xsmall__ceCDZ","small":"Text_small__1btO5","medium":"Text_medium__9tg0J","large":"Text_large__K0vNo","bold":"Text_bold__15LWX"};